// @ts-nocheck

import React, { useState } from 'react';
import { useCollection } from '@cloudscape-design/collection-hooks';
import {
  Box,
  Button,
  CollectionPreferences,
  Header,
  Pagination,
  Table,
  TextFilter,
} from '@cloudscape-design/components';
import { columnDefinitions, getMatchesCountText, paginationLabels, collectionPreferencesProps } from './table-config';
import { truncate } from 'fs';

function EmptyState({ title, subtitle, action }) {
  return (
    <Box textAlign="center" color="inherit">
      <Box variant="strong" textAlign="center" color="inherit">
        {title}
      </Box>
      <Box variant="p" padding={{ bottom: 's' }} color="inherit">
        {subtitle}
      </Box>
      {action}
    </Box>
  );
}


export default function ResultsTable( tableItems, visibleColumns, tableLoading ) {
  const [preferences, setPreferences] = useState({ pageSize: 10, visibleContent: visibleColumns });
  const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = useCollection(
    tableItems,
    {
      filtering: {
        empty: <EmptyState title="No results" />,
        noMatch: (
          <EmptyState
            title="No results"
            action={<Button onClick={() => actions.setFiltering('')}>Clear filter</Button>}
          />
        ),
      },
      pagination: { pageSize: preferences.pageSize },
      sorting: {},
      selection: {},
    }
  );
  const { selectedItems } = collectionProps;
  return (
    <>
      {/* <div style={{display: "flex", width: "100%", justifyContent: "flex-end", fontSize: "1.1rem", fontWeight: "bold", color: "darkgray"}}>
        {`${tableItems.length} Drivers`}
      </div> */}
      <Table
        // className="results-table"
        data-table
        resizableColumns={false}
        trackBy="irUserName"
        variant="embedded"
        loading={tableLoading}
        loadingText="Loading results"
        stickyHeader
        sortingDisabled
        {...collectionProps}
        // selectionType="multi"
        // onRowClick={({ detail }) => {
        //   console.table(detail.item)
        // }}
        header={
          <Header
            // counter={selectedItems.length ? `(${selectedItems.length}/${tableItems.length})` : `(${tableItems.length})`}
          >
            {/* Qualifying Results */}
          </Header>
        }
        columnDefinitions={columnDefinitions}
        visibleColumns={preferences.visibleContent}
        items={items}
        // pagination={<Pagination {...paginationProps} ariaLabels={paginationLabels}/>}
        // filter={
        //   <TextFilter
        //     {...filterProps}
        //     countText={getMatchesCountText(filteredItemsCount)}
        //     filteringAriaLabel="Filter instances"
        //     filteringPlaceholder='Enter a value to filter results records...'
        //   />
        // }
        // preferences={
        //   <CollectionPreferences
        //     {...collectionPreferencesProps}
        //     preferences={preferences}
        //     onConfirm={({ detail }) => setPreferences(detail)}
        //   />
        // }
      />
    </>
  );
}